
export interface InstructorPlanDetails {
  id:string;
  name:string;
  pricePerMonth: number,
  pricePerYear: number,
  monthlyEquivalentForYearlyPlan: number,
  upgradeToProDiscount?: number;
  pricingDetails: {
    monthly: string;
    yearly: string;
  }
}

export const instructorPlans: {[key:string]:InstructorPlanDetails} = {
  growth: {
    id: "growth",
    name: "Free Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,

    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  basic: {
    id: "basic",
    name: "Basic Plan",
    pricePerMonth: 25,
    pricePerYear: 250,
    monthlyEquivalentForYearlyPlan: 21,
    pricingDetails: {
      monthly: "$25/month",
      yearly: "$21/month ($250 billed annually)"
    }
  },
  pro: {
    id: "pro",
    name: "Pro Plan",
    pricePerMonth: 59,
    pricePerYear: 590,
    monthlyEquivalentForYearlyPlan: 49,
    pricingDetails: {
      monthly: "$59/month",
      yearly: "$49/month ($590 billed annually)"
    }
  },
  enterprise: {
    id: "enterprise",
    name: "Enterprise Plan",
    pricePerMonth: 129,
    pricePerYear: 1285,
    monthlyEquivalentForYearlyPlan: 107,
    pricingDetails: {
      monthly: "$129/month",
      yearly: "$107/month ($1285 billed annually)"
    }
  },
  founder: {
    id: "founder",
    name: "Founder Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  lifetime: {
    id: "lifetime",
    name: "Lifetime Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-basic": {
    id: "lifetime-basic",
    name: "Lifetime Basic Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    upgradeToProDiscount: 50,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-basic-appsumo": {
    id: "lifetime-basic-appsumo",
    name: "AppSumo Lifetime Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    upgradeToProDiscount: 50,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-pro": {
    id: "lifetime-pro",
    name: "Lifetime Pro Plan",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  },
  "lifetime-pro-v2": {
    id: "lifetime-pro-v2",
    name: "AppSumo Lifetime Plan v2",
    pricePerMonth: 0,
    pricePerYear: 0,
    monthlyEquivalentForYearlyPlan: 0,
    pricingDetails: {
      monthly: "",
      yearly: ""
    }
  }


};

export const instructorPlansFrequency: {[key:string]:string} = {
  "monthly": "Monthly",
  "yearly": "Yearly"
}
